<template>
    <!-- 86bce6r42: the self report's checkout, as a popup over the "ready" page:
         centred on desktop, a bottom sheet on mobile (TosReacceptanceModal's layout).
         The card form only mounts while the popup is open. -->
    <TransitionRoot as="template" :show="show">
        <HeadlessDialog as="div" class="relative z-40" @close="emit('close')">
            <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>
            <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div class="flex min-h-full items-end justify-center sm:items-center sm:p-4">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                        <DialogPanel class="relative w-full transform overflow-hidden rounded-t-2xl bg-white px-4 pb-6 pt-5 text-left shadow-xl transition-all sm:max-w-xl sm:rounded-lg sm:p-6" data-test="unlock-dialog">
                            <div class="mx-auto mb-4 h-1 w-10 rounded-full bg-gray-300 sm:hidden" aria-hidden="true" />
                            <div class="flex items-start justify-between gap-4">
                                <div>
                                    <DialogTitle as="h3" class="text-xl font-bold text-gray-900">Unlock your report</DialogTitle>
                                    <p class="mt-1 text-sm text-gray-600">Your report is built and ready to view.</p>
                                </div>
                                <button
                                    type="button"
                                    class="rounded-md p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                                    aria-label="Close"
                                    data-test="close-unlock-dialog"
                                    @click="emit('close')"
                                >
                                    <font-awesome-icon :icon="faXmark" class="h-5 w-5" aria-hidden="true" />
                                </button>
                            </div>

                            <self-check-cart-summary
                                class="mt-4"
                                :report-id="reportId"
                                :summary-lines="checkout.summary_lines"
                                :amount="checkout.amount"
                                :discount="checkout.discount"
                                :leaving="checkout.leaving"
                                :seconds-left="secondsLeft"
                                :countdown="countdown"
                            />

                            <stripe-form
                                class="mt-4"
                                :publishable_key="checkout.publishable_key"
                                :payment_intent="checkout.payment_intent"
                                :amount="checkout.amount"
                                :first_name="checkout.first_name"
                                :last_name="checkout.last_name"
                                billing_type="report"
                                :report_id="String(reportId)"
                            />
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </HeadlessDialog>
    </TransitionRoot>
</template>

<script setup>
import { Dialog as HeadlessDialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faXmark } from '@fortawesome/pro-solid-svg-icons'
import SelfCheckCartSummary from '@/Components/SelfCheckCartSummary.vue'
import StripeForm from '@/Components/StripeForm.vue'

defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    reportId: {
        type: [String, Number],
        required: true,
    },
    checkout: {
        type: Object,
        required: true,
    },
    secondsLeft: {
        type: Number,
        default: 0,
    },
    countdown: {
        type: String,
        default: '0:00',
    },
})

const emit = defineEmits(['close'])
</script>
